require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.regexp.constructor");

var moment = require('moment');

var Parser = require('../parser').Parser;

var ParsedResult = require('../../result').ParsedResult;

var util = require('../../utils/EN');

var PATTERN = new RegExp('' + '(\\W|^)' + '(?:within\\s*)?' + '(' + util.TIME_UNIT_PATTERN + ')' + '(?:ago|before|earlier)(?=(?:\\W|$))', 'i');
var STRICT_PATTERN = new RegExp('' + '(\\W|^)' + '(?:within\\s*)?' + '(' + util.TIME_UNIT_STRICT_PATTERN + ')' + 'ago(?=(?:\\W|$))', 'i');

exports.Parser = function ENTimeAgoFormatParser() {
  Parser.apply(this, arguments);

  this.pattern = function () {
    return this.isStrictMode() ? STRICT_PATTERN : PATTERN;
  };

  this.extract = function (text, ref, match, opt) {
    if (match.index > 0 && text[match.index - 1].match(/\w/)) return null;
    var text = match[0];
    text = match[0].substr(match[1].length, match[0].length - match[1].length);
    var index = match.index + match[1].length;
    var result = new ParsedResult({
      index: index,
      text: text,
      ref: ref
    });
    var fragments = util.extractDateTimeUnitFragments(match[2]);
    var date = moment(ref);

    for (var key in fragments) {
      date.add(-fragments[key], key);
    }

    if (fragments['hour'] > 0 || fragments['minute'] > 0 || fragments['second'] > 0) {
      result.start.assign('hour', date.hour());
      result.start.assign('minute', date.minute());
      result.start.assign('second', date.second());
      result.tags['ENTimeAgoFormatParser'] = true;
    }

    if (fragments['d'] > 0 || fragments['month'] > 0 || fragments['year'] > 0) {
      result.start.assign('day', date.date());
      result.start.assign('month', date.month() + 1);
      result.start.assign('year', date.year());
    } else {
      if (fragments['week'] > 0) {
        result.start.imply('weekday', date.day());
      }

      result.start.imply('day', date.date());
      result.start.imply('month', date.month() + 1);
      result.start.imply('year', date.year());
    }

    return result;
  };
};